import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { HERO_IMAGE } from "../../data/site";

/*
 * The scroll, temple, Navkar sheet, books, manuscript, pot and floral border come from the
 * approved hero artwork (public/images/hero). Text, buttons and Gurudev's photo are live layers
 * placed at the artwork's own coordinates. The artwork frame is scaled so its content
 * (temple through brass pot) spans the same centred container as the other sections.
 */
export function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-stage">
        <div className="hero-temple" aria-hidden="true" />
        <div className="hero-copy">
          <h1 id="hero-title" className="hero-title">
            <span className="hero-line hero-line--1">Preserving Jain</span>
            <span className="hero-line hero-line--2">Knowledge for</span>
            <span className="hero-line hero-line--3">Future Generations</span>
          </h1>
          <p className="hero-lede">
            A digital ecosystem inspired by the teachings and research legacy of
            Gurudev Muni Jambuvijayaji Maharaj Saheb (1923–2009).
          </p>
          <div className="hero-actions">
            <Link to="/emagazine" className="hero-btn hero-btn--primary">
              E Magazine
              <ArrowRight aria-hidden="true" />
            </Link>
            <Link to="/about/gurudev" className="hero-btn hero-btn--outline">
              <BookOpen aria-hidden="true" />
              Learn About Gurudev
            </Link>
          </div>
        </div>
        <div className="hero-frame">
          <div className="hero-visual">
            <img
              className="hero-gurudev"
              src={HERO_IMAGE.src}
              alt={HERO_IMAGE.alt}
              width={921}
              height={1212}
              {...{ fetchpriority: "high" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
